// extracted by mini-css-extract-plugin
export default {"title":"bbbe0037ee","inner_title":"dcf93c7639","charge_btn":"fc97b48ec1"};